import React from 'react';
import { useNavigate } from 'react-router-dom';

function Games() {
  const navigate = useNavigate();

  const linkStyle = {
    display: 'block',
    padding: '15px',
    margin: '10px auto',
    maxWidth: '600px',
    backgroundColor: '#333',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    transition: 'background-color 0.3s ease, transform 0.3s ease',
    textAlign: 'left',
  };

  const handleMouseOver = (e) => {
    e.currentTarget.style.backgroundColor = '#555';
    e.currentTarget.style.transform = 'translateY(-3px)';
  };

  const handleMouseOut = (e) => {
    e.currentTarget.style.backgroundColor = '#333';
    e.currentTarget.style.transform = 'translateY(0)';
  };

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Games Page</h1>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '40px' }}>
        <a
          href="https://thrillartsgames.com/"
          
          style={{
            display: 'inline-block',
            padding: '15px 30px',
            fontSize: '1.2em',
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: '#007bff',
            border: 'none',
            borderRadius: '8px',
            textDecoration: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            marginTop: '20px',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
        >
          Play Dice Game
        </a>
        <a
          href="https://apps.apple.com/us/app/dice-game-fx/id6752764254"
          style={{
            display: 'inline-block',
            padding: '15px 30px',
            fontSize: '1.2em',
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: '#000000',
            border: '2px solid #ffffff',
            borderRadius: '8px',
            textDecoration: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            marginTop: '20px',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#333'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#000000'}
        >
          Download on the App Store
        </a>
      </div>

      <div className="setup">
        <h1>More Games from ThrillArts</h1>
        
        <a href="https://horizon.meta.com/world/807648922422359/?hwsh=hz8eyzIbIg" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <h3>Mountain Trail</h3>
            <p>Step into a world of mystery and adventure. Sharpen your senses and uncover hidden objects in this captivating VR experience.</p>
            <p style={{color: '#4CAF50', marginTop: '10px'}}>Click to play!</p>
        </a>

        <a href="https://horizon.meta.com/world/790037324183519/?hwsh=8yzDbrqxDo" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <h3>ThrillArts Games : Graveyard Bash</h3>
            <p>Lace up your gloves and step into the ring. Experience the raw intensity of VR Graveyard Bash zombies your way to the top.</p>
            <p style={{color: '#4CAF50', marginTop: '10px'}}>Click to play!</p>
        </a>

        <button onClick={() => navigate('/')} style={{marginTop: '20px', padding: '10px 20px', fontSize: '1em', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'}}>
          Go Back Home
        </button>
      </div>
    </div>
  );
}

export default Games;